'use strict';

import React from 'react';
import { HashRouter, Route, withRouter } from 'react-router-dom';
import DockBar from '../components/dockbar/DockBar';
import Agreement from '../components/agreement/Agreement';

import Logger from '../utils/Logger';
import '!style-loader!css-loader!sass-loader!./../style.scss';
import SessionUtils from '../utils/SessionUtils';
import Misc from '../definitions/Misc';

// api client

// sample data

const { id: module_id } = module;
const logger = Logger(module_id);

const defaultLocale = 'fi_FI';

const AgreementDockbar = withRouter(({ location }) => (
  <DockBar logoLink={location.pathname} />
));

class AgreementBase extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    Misc.alterSkipToContent();
  }

  render() {
    let { agreementUserInfo } = this.props;
    return (
      <div>
        <div>
          <HashRouter>
            <div>
              <div className="row-fluid">
                {/* Render basic topbar without any actions since user is not known at this phase*/}
                <AgreementDockbar />
              </div>

              <div className="row-fluid ot-maincontainer">
                <div>
                  <Route
                    path="/"
                    render={(props) => (
                      <Agreement
                        {...props}
                        agreementUserInfo={agreementUserInfo}
                      />
                    )}
                  />
                  <Route path="/logout" render={() => SessionUtils.logout()} />
                </div>
              </div>
            </div>
          </HashRouter>
        </div>
      </div>
    );
  }
}

export default AgreementBase;
